import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { lazy } from "react";

const Index = lazy(() => import("@/pages/Index"));

const RootRoute = () => {
  const { loading, session, user, profile } = useAuth();

  const accountType = user?.user_metadata?.account_type;
  const isBrand = accountType === "brand";
  const isAgency = !!profile?.agency_id || accountType === "agency" || accountType === "team_member";

  // Brands have no profiles row, so don't wait for one.
  const isWaiting = loading || (!!session && !profile && !isBrand);

  if (isWaiting) {
    return null;
  }

  if (!session) {
    return <Index />;
  }

  if (user && !user.email_confirmed_at) {
    return <Navigate to={`/verify-email?email=${encodeURIComponent(user.email || "")}${isBrand ? "&type=brand" : ""}`} replace />;
  }

  if (isBrand) {
    return <Navigate to="/brand" replace />;
  }

  if (!profile?.onboarding_done) {
    return <Navigate to={isAgency ? "/agency/onboarding" : "/onboarding"} replace />;
  }

  return <Navigate to={isAgency ? "/agency/inbox" : "/inbox"} replace />;
};

export default RootRoute;
